import cn from "classnames";
import React, { FC, useState, HTMLAttributes, useEffect, useMemo } from "react";
import { ReactComponent as TickIcon } from "images/TickIcon.svg";
import { ReactComponent as EmptyIcon } from "images/empty-tray-svgrepo-com.svg";
import styles from "./MySelect.module.sass";

interface MySelectProps extends HTMLAttributes<HTMLDivElement> {
	value: string;
	name: string;
	placeholder: string;
	set: (e: any) => void;
	list: { id: number; name: string; subtitle?: string }[];
	width?: string;
	required?: boolean;
	error?: boolean;
	scroll?: boolean;
	disabled?: boolean;
	search?: boolean;
}

export const MySelect: FC<MySelectProps> = ({
	className,
	name,
	list,
	set,
	placeholder,
	value,
	width,
	required,
	error,
	scroll = true,
	disabled = false,
	search = true,
}) => {
	const [isFocus, setIsFocus] = useState<boolean>(false);
	const [searchValue, setSearchValue] = useState<string>("");
	const [cleared, setCleared] = useState<boolean>(false);
	const setHandler = (item: { id: number; name: string }) => {
		set(item);
		setSearchValue(item.name);
		setCleared(false);
	};

	useEffect(() => {
		if (value && searchValue !== value) {
			set({ id: null, name: "" });
			setCleared(true);
		}
		//eslint-disable-next-line
	}, [searchValue]);

	useEffect(() => {
		if (value) {
			setSearchValue(value);
			setCleared(false);
		} else {
			if (!cleared) {
				setSearchValue(value);
				setCleared(true);
			}
		}
		//eslint-disable-next-line
	}, [value]);
	const [isEmpty, setIsEmpty] = useState<boolean>(false);
	const renderList = useMemo(() => {
		const filtredList: any[] = [];
		const residualList: any[] = [];
		if (search) {
			list.forEach((item) => {
				if (item.name.toLowerCase().includes(searchValue.toLowerCase().trim())) filtredList.push(item);
				else residualList.push(item);
			});
			filtredList[filtredList.length - 1] = { ...filtredList[filtredList.length - 1], last: true };
			if (!filtredList.length) setIsEmpty(true);
			else setIsEmpty(false);
			return [...filtredList, ...residualList];
		} else return [];
		//eslint-disable-next-line
	}, [searchValue, list]);

	return (
		<div className={cn(className, styles["select-wrp"], styles[`${width}`])}>
			<span
				className={cn(
					`${isFocus ? styles["title-focus"] : disabled ? styles["title-disabled"] : styles.title}`,
					error && !value?.trim() ? "error-input-title" : "",
				)}>
				{name}
				{required && <span className="red"> *</span>}
			</span>
			<div className={styles["input-wrp"]}>
				<input
					className={cn(
						disabled ? styles["input-disabled"] : styles.input,
						error && !value?.trim() ? "error-input" : "",
					)}
					value={searchValue}
					onChange={(e) => setSearchValue(e.target.value)}
					onFocus={() => setIsFocus(true)}
					onBlur={() => setIsFocus(false)}
					readOnly={!list.length || !search}
					type="text"
					placeholder={placeholder}
				/>
				<TickIcon className={cn(styles["input-icon"], disabled && styles["input-icon-disabled"])} />
			</div>
			{isFocus && (
				<div className={styles.select}>
					{(search && renderList.length) || (!search && list.length) ? (
						<ul className={cn(styles.list, !scroll && styles.noScroll)}>
							{isEmpty && (
								<>
									<div className={styles.empty}>
										<div>
											<EmptyIcon className={styles["empty-icon"]} />
										</div>
										<span className={styles["empty-txt"]}>Совпадений не найдено</span>
									</div>
									<hr />
								</>
							)}
							{(searchValue.trim() && search && !value ? renderList : list).map((item, i) => (
								<React.Fragment  key={item.id}>
									<li className={styles.item}>
										<button onMouseDown={() => setHandler(item)} type="button" className={styles.button}>
											<span className={styles.subtitle}>{item.subtitle}</span>
											<span className={styles.name}>{item.name}</span>
										</button>
									</li>
									{item?.last && i !== renderList.length - 1 && <hr />}
								</React.Fragment>
							))}
						</ul>
					) : (
						<span className={styles.warning}>Ничего не найдено</span>
					)}
				</div>
			)}
		</div>
	);
};
